import { safeSessionStorage } from "@/utils/safeStorages";
import React from "react";
import siteConfig from "../variables";

const { KEY_SESSION_ID, KEY_AFFILIATE_SESSION } = siteConfig;

/**
 *
 * useStoredSession is used return sessionIds saved in sessionStorage.
 * Optionally you can provide the header from another call to update the headers in place.
 *
 * @param headers
 * @returns
 */
export const useStoredSessions = () => {
  // This hook intentionally doesn't use state as we want to avoid a number of re-renders
  const update = React.useCallback((headers: Record<string, string>) => {
    const parsedHeaders = headers || {};

    const incomingSessionId = parsedHeaders["x-session-id"];
    const incomingAffiliateId = parsedHeaders["x-affiliate-id"];

    // This is used in all XHR requests through app, see useRequests.ts
    // And most of the API endpoints doesn't provide these info below
    // We have these if statements below to prevent setting these values into undefined
    if (incomingSessionId) safeSessionStorage.setItem(KEY_SESSION_ID, incomingSessionId);
    if (incomingAffiliateId) safeSessionStorage.setItem(KEY_AFFILIATE_SESSION, incomingAffiliateId);
  }, []);

  const getValues = React.useCallback(
    () => ({
      sessionId: safeSessionStorage.getItem(KEY_SESSION_ID) ?? undefined,
      affiliateId: safeSessionStorage.getItem(KEY_AFFILIATE_SESSION) ?? undefined,
    }),
    [],
  );

  return {
    getValues,
    update,
  };
};
